import { useCallback, useRef, useState } from "react";
import { useUnmount, useUpdateEffect } from "react-use";
import debounce from "lodash/debounce";
import { useNetworkStatusChange } from "~/components/Hooks/useNetworkStatusChange";
import { useVisibility } from "./useVisibility";

const TIMEOUT_THRESHOLD = 60;
export const useNetworkStateChange = (cb = () => null, threshold = TIMEOUT_THRESHOLD) => {
  const [since, setSince] = useState(0);
  const [visibility, setVisibility] = useState(() => Date.now());
  const [duration, setDuration] = useState(0);

  const refresh = useRef(debounce(cb, 3000)).current; //3 sec is somehow normal when you switch wifi networks

  const onOnline = () => {
    if (since) {
      const _duration = Math.round((Date.now() - since) / 1000);
      setDuration(_duration);
    }
  };

  const onOffline = () => {
    setSince(Date.now());
  };

  useNetworkStatusChange(onOnline, onOffline);

  const handleVisible = useCallback(() => {
    const _duration = Math.round((Date.now() - visibility) / 1000);
    if (!isNaN(_duration)) {
      setDuration(_duration);
    }
  }, [visibility]);

  const handleHidden = useCallback(() => {
    setDuration(0);
    setVisibility(Date.now());
  }, []);

  useUpdateEffect(() => {
    if (duration >= threshold) {
      setDuration(0);
      refresh();
    }
  }, [duration, refresh, threshold]);

  useVisibility(handleVisible, handleHidden);

  useUnmount(() => {
    refresh?.cancel();
  });
};
